import 'fslightbox'

window.addEventListener('bw-refresh-lightbox', () => {
  // @ts-expect-error: CDN
  refreshFsLightbox()
})

window.addEventListener('load', () => {
  const hash = window.location.hash

  if (!hash) return

  const lightbox: HTMLElement | null = document.querySelector(
    `[data-fslightbox="${hash.split('#')[1]}"]`,
  )

  if (!lightbox) return

  lightbox.click()
})
